<template>
  <div class="forgot-password-container">
    <AppLogo/>
    <PageHeader>Восстановить пароль</PageHeader>
    <form @submit.prevent="sendEmail">
      <InputField
          v-model="email"
          placeholder="Электронная почта"
          type="email"
          name="email"
          v-if="!message"
      />
      <button class="reset-button" type="submit" v-if="!message">Сбросить пароль</button>

      <InstructionHelp v-if="!message && !errorMessage">
        Инструкции по восстановлению пароля будут направлены на вашу почту
      </InstructionHelp>
    </form>

    <div v-if="message" class="message">{{ message }}</div>
    <div v-else-if="errorMessage" class="error-message">{{ errorMessage }}</div>
  </div>
</template>

<script setup>
import { ref } from 'vue'

import AppLogo from '@/components/auth/AppLogo.vue'
import PageHeader from '@/components/auth/PageHeader.vue'
import InputField from '@/components/auth/InputField.vue'
import InstructionHelp from '@/components/auth/InstructionHelp.vue'
import { forgotPassword } from '@/utils/requests'

const email = ref(null)
const message = ref(null)
const errorMessage = ref(null)

const sendEmail = async () => {
  try {
    const response = await forgotPassword(email.value)

    if (!response.ok) {
      throw new Error('Не удалось отправить письмо')
    }

    const json = await response.json()

    if (json.success) {
      errorMessage.value = null
      message.value = 'Письмо с ссылкой на восстановление пароля было отправлено на вашу почту'
    } else {
      errorMessage.value = 'Неизвестная ошибка. Попробуйте заново или обратитесь в поддержку'
    }
  } catch (e) {
    console.error(e)
    errorMessage.value = 'Не удалось отправить письмо. Перезагрузите страницу и попробуйте заново'
  }
}
</script>

<style scoped>
.forgot-password-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100vh;
  max-width: 400px;
  margin: auto;
  text-align: center;
}

form {
  display: flex;
  flex-direction: column;
}

.reset-button {
  background-color: #000;
  color: #fff;
  padding: 10px;
  font-size: 16px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-weight: bold;
}

.reset-button:hover {
  background-color: #333;
}

.message {
  color: green;
  margin-top: 15px;
}

.error-message {
  color: red;
  margin-top: 15px;
}
</style>
